import {ChangeDetectionStrategy, Component, input, InputSignal} from "@angular/core";

@Component({
    selector: "woa-watermark",
    templateUrl: "./watermark.component.html",
    styleUrl: "./watermark.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WatermarkComponent {
    public readonly text: InputSignal<string> = input.required<string>();
}
